<template lang="pug">
  footer.footer()
    .bg-gray
      .wrapper
        FooterLaboratorio
    .bg-red
      .wrapper
        FooterCopesa
</template>

<script>
  import { mapState } from 'vuex'
  import FooterLaboratorio from '@/components/FooterLaboratorio'
  import FooterCopesa from '@/components/FooterCopesa'

  export default  {
    components: {
      FooterCopesa,
      FooterLaboratorio
    },
    computed: mapState([
      'config'
    ])
}
</script>

<style scoped lang="scss">
  .footer{
    position: relative;
    z-index: 2;
    &.hid{
      z-index: 1;
    }
  }
  .bg-red {
    background-color: #b10925;
    border-top: 10px solid #870d20;
    padding: 2rem 0;
  }
  .wrapper{
    margin: 0 auto;
    max-width: 1170px;
    padding: 0 1rem;
  }
  .bg-gray{
    background-color: lighten(black, 15%);
    padding: 1rem 0;
  }
</style>
